import { createStyles, makeStyles } from '@material-ui/core/styles'

import { lengthOfDayInPx, totalDays } from './utils/constants'

export const useStyles = makeStyles(({ palette }) =>
  createStyles({
    container: {
      display: 'flex',
      flexDirection: 'column',

      height: '100%',
      padding: '3.2rem 2rem',
      margin: '0 auto',

      minWidth: '131.6rem',
      maxWidth: '131.6rem',

      '& > h3': {
        fontSize: '1.6rem',
      },
    },

    titleContainer: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginBottom: '1.4rem',
      maxWidth: '121.6rem',
    },

    calendarHeaderContainer: {
      margin: '0 1rem 0 20.6rem',

      '& > div': {
        width: `${totalDays * lengthOfDayInPx}px`,
      },
    },

    calendarActivitiesContainer: {
      position: 'relative',
      display: 'flex',
      flexDirection: 'column',
      minHeight: 0,
      height: '100%',
    },

    newActivityContainer: {
      position: 'absolute',

      bottom: '3.2rem',
      right: '4rem',
      zIndex: 2,
    },

    newActivityButton: {
      margin: 0,

      marginLeft: '1rem',
      width: 'fit-content',
      height: '3.2rem',
      gap: '1rem',

      backgroundColor: palette.secondary.main,

      '&:not(:disabled):hover': {
        backgroundColor: palette.text.primary,
      },

      '& > svg': {
        fontSize: '1.6rem',
      },
    },
  }),
)
